export default __webpack_public_path__ + "static/media/thirteen.17b5a6a2.png";